import useMutationCall from "../../../hooks/useMutationCall";
import { useAddEmployeeMutation } from "../employeesSlice";

const useAddEmployee = () => {
  return useMutationCall(useAddEmployeeMutation);
};

export default useAddEmployee;
